import React, { useState, useEffect } from "react";
import "./thankyou.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { fetchCurrentQuestion, updategameover } from "../../scoreservice";

function Thankyou({ updateHeader }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, SetriddlerusLogo] = useState("/img/thankyou-min.gif");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData'));

  const [textcolor, Setcolorcode] = useState(null);
  const [score, setScore] = useState(0);
  const [time, setTime] = useState(0);
  const [fetchError, setFetchError] = useState(false);
  
  const handleSuccess = (msg) => {
    return Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: msg,
      confirmButtonText: 'OK',
      customClass: { popup: 'custom-success-popup' }
    });
  };
  
    const handleError = (msg) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: msg,
        customClass: { popup: 'custom-success-popup' }
      });
    };

  useEffect(() => {

    updateHeader({
      backButtonRedirect: "/game"
    });

    const fetchData = async () => {
      const storedSession = sessionStorage.getItem("userData");
      console.log(storedSession);
      const storedTheme = sessionStorage.getItem("themeData");

      if (storedSession && storedTheme) {
        const parsedUser = JSON.parse(storedSession);
        const parsedTheme = JSON.parse(storedTheme);

        setUserData(parsedUser);
        setThemeData(parsedTheme);
        Setcolorcode(parsedTheme.landing_page_title_color);
        console.log("Theme Rules:", parsedTheme.rules);
      } else {
        navigate("/login"); // Redirect if session data is missing
      }
    };

    fetchData();
  }, [navigate]);

  useEffect(() => {
    if (!storedUserData?.sessionId) return;

    const reportData = {
    sessionId: storedUserData.sessionId,
    organizationId: storedUserData.organizationId,
    userId: storedUserData.userId || storedUserData.userid,
    gameover: true
  };
    console.log("reportData",reportData);

    updategameover(reportData)
      .then(res => {
        const data = typeof res === "string" ? JSON.parse(res) : res;
        if (data.status === "success") {
          console.log("all Questions", data.data);


        } else {
          handleError(data.message);
          setFetchError(true);
        }
      })
      .catch(err => { console.error(err); setFetchError(true); });

    fetchCurrentQuestion(reportData)
      .then((res) => {
        const data = typeof res === "string" ? JSON.parse(res) : res;
        if (data.status === "success") {
          setScore(data.data[0].total_score);
          setTime(data.data[0].time);
          console.log("fetch php data", data.data[0]);
          // console.log("currentQuestionIndex",currentQuestionIndex);
        } else {
          console.error("FetchQuestions Error:", data.message);
        }
      })
      .catch((err) => console.error("FetchQuestions Exception:", err));
    // We intentionally leave dependency array empty
  }, []);


  useEffect(() => {
    if (themeData != null) {
      const body = document.body;

      if (body.classList.contains('common-bg')) {
        // Check if it's a mobile device (or you can define your own breakpoint)
        if (window.innerWidth <= 768) {
          // Apply mobile background
          console.log(themeData.background_mob);
          body.style.backgroundImage = `url(${themeData.background_mob})`;
        } else {
          // Apply desktop background
          console.log(themeData.background_desk);
          body.style.backgroundImage = `url(${themeData.background_desk})`;
        }
      }

      //   SetriddlerusLogo(themeData.logo);
    }
  }, [themeData]);

  return (
    <>
      <div className="thankyou-main-container" style={{ textAlign: "center" }}>
        <div className="thankyou-main-container1" style={{ textAlign: "center" }}>
          <img src={riddlerusLogo} className="login-logo" />
        </div>

        {/* <div className="text-main-container" style={{ textAlign: "center" }}>
          <h4 style={{ color: textcolor }} id="introtext">RULES</h4>
        </div> */}

        <div>

          <p className="score" style={{ margin: "10px 0", color: textcolor }}>
            You have scored  <strong>{score}  points </strong> in <strong>{time}</strong> minutes.
          </p>
          <p style={{ margin: "16px 0" }}>
            <Link
              to="/leaderboard"
              className="thankyou-leaderboard-link"
              style={{ color: textcolor }}
            >
              View Leaderboard
            </Link>
          </p>
          {/* <p style={{ fontSize: "25px", margin: "10px 0",color: textcolor }}>
            Time: <strong>{time}s</strong>
            </p> */}
        </div>


      </div>

    </>

  );
}
export default Thankyou;